import { camelToKebab as t } from "./parsers/index.mjs";
import "./createParser/index.mjs";
function c(o, r = t) {
  if (!o || typeof o != "object" || Array.isArray(o))
    throw new TypeError(`expected an argument of type object, but got ${typeof o}`);
  return Object.keys(o).map((e) => `${r(e)}: ${o[e]};`).join(`
`);
}
export {
  c as default
};
